import { type MouseEventHandler, type ReactNode } from 'react'

import {
  TooltipBox,
  TooltipWrapper,
  type TooltipPlacement,
} from '@/components/global/Tooltip/Tooltip.styled'
import { Text } from '@/components/priority/Text/Text'

type TooltipProps = {
  text: string
  children: ReactNode
  /** Placement of tooltip relative to children. Default: 'above' */
  placement?: TooltipPlacement
  /** Fine-tune horizontal offset in pixels */
  offsetX?: number
  /** Fine-tune vertical offset in pixels */
  offsetY?: number
  width?: string
  height?: string
  padding?: string
  /** Margin around the tooltip wrapper */
  margin?: string
  /** Click handler for the tooltip wrapper */
  onClick?: MouseEventHandler<HTMLDivElement>
  /** Whether the tooltip content is clickable (adds cursor: pointer) */
  clickable?: boolean
  /** Whether the tooltip is disabled */
  disabled?: boolean
}

export const Tooltip = ({
  text,
  children,
  placement = 'above',
  offsetX = 0,
  offsetY = 8,
  width,
  height,
  padding = '6px',
  margin,
  onClick,
  clickable,
  disabled,
}: TooltipProps) => {
  return (
    <TooltipWrapper
      center
      column
      position="relative"
      margin={margin}
      onClick={onClick}
      disabled={disabled}
      $clickable={clickable}
    >
      <TooltipBox
        center
        padding={padding}
        margin="0"
        radius="2px"
        background="gray1"
        width={width}
        height={height}
        $placement={placement}
        $offsetX={offsetX}
        $offsetY={offsetY}
      >
        <Text
          color="white"
          size="12px"
          weight="500"
          whiteSpace={width ? 'normal' : 'nowrap'}
        >
          {text}
        </Text>
      </TooltipBox>
      {children}
    </TooltipWrapper>
  )
}
